function subFormatDate(timeStr, formatStr) {
  if (!timeStr) return "";
  let str = timeStr;

  // 兼容带有时区偏移，且时间部分可能是hh:mm或hh:mm:ss（可无秒）
  // 支持 '1997-11-07T06:30+08:00' 以及 '1997-11-07T06:30:00+08:00' 和同类写法
  let tzMatch = str.match(
    /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2})?)(\.\d+)?([+-]\d{2}:\d{2})$/
  );
  let fixedDate = '';

  if (tzMatch) {
    let datePart = tzMatch[1];
    let timePart = tzMatch[2];     // 可能为hh:mm或hh:mm:ss
    // let msPart = tzMatch[3] ? tzMatch[3] : '';


    let [year, month, day] = datePart.split('-');
    // 时间部分拆分（根据:切分，若缺少秒补零）
    let timeArr = timePart.split(':');
    let hour = parseInt(timeArr[0], 10);
    let minute = parseInt(timeArr[1], 10);
    let second = timeArr.length >= 3 ? parseInt(timeArr[2], 10) : 0;

    // 直接用构建本地时间，不进行时区偏移换算（即展示本地字面时间）
    // 构造 Date 对象时用本地时间
    fixedDate = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      hour,
      minute,
      second
    );

    return formatDate(fixedDate, formatStr);
  }

  // // 其他情况，兼容之前的处理
  // if (str.indexOf(".") !== -1) {
  //   str = str.replace(/-/g, '/').replace(/T/g, ' ').replace(/Z/g, '');
  //   str = str.substr(0, str.indexOf('.'));
  // } else {
  //   str = str.replace(/-/g, '/')
  // }
  fixedDate = new Date(str);

  return formatDate(fixedDate, formatStr);
}


// 根据用户传入的本地中国时间字符串，不论当前代码运行环境在哪 (如德国、美国等)，都返回中国北京时间（东八区）的字符串（不进行时区换算）。
function IOSFormtDate(timeStr) {
  if (!timeStr) return "";
  // 仅支持最常见的格式（如 "YYYY-MM-DD HH:mm:ss" 或 "YYYY-MM-DD"），总是按“输入的时间就是中国时间”处理
  let srcStr = typeof timeStr === "string" ? timeStr.trim() : "";
  let year, month, day, hour = 0, minute = 0, second = 0;

  // 仅日期
  if (/^\d{4}-\d{2}-\d{2}$/.test(srcStr)) {
    [year, month, day] = srcStr.split('-').map(Number);
  } 
  // 日期+时间（中间空格或T）
  else if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(srcStr)) {
    let parts = srcStr.split(/[ T]/);
    [year, month, day] = parts[0].split('-').map(Number);
    let timeArr = parts[1].split(':').map(Number);
    hour = timeArr[0];
    minute = timeArr[1];
    second = timeArr.length > 2 ? timeArr[2] : 0;
  } 
  // 否则用Date解析（数字时间戳或者其它 Date 可接受类型）
  else if (srcStr) {
    let d = new Date(srcStr);
    if (isNaN(d.getTime())) return "";
    year = d.getFullYear();
    month = d.getMonth() + 1;
    day = d.getDate();
    hour = d.getHours();
    minute = d.getMinutes();
    second = d.getSeconds();
  } else if (typeof timeStr === "number" || timeStr instanceof Date) {
    let d = new Date(timeStr);
    if (isNaN(d.getTime())) return "";
    year = d.getFullYear();
    month = d.getMonth() + 1;
    day = d.getDate();
    hour = d.getHours();
    minute = d.getMinutes();
    second = d.getSeconds();
  } else {
    return "";
  }

  // 固定中国时区东八区输出
  function pad(val, len = 2) { return String(val).padStart(len, '0'); }
  return (
    `${pad(year, 4)}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}+08:00`
  );
}



/**
 * 格式化日期
 * @param {string | number | Date} vtimelue 指定日期
 * @param {string} formatStr 格式化的规则
 * formatDate(1603264465956, "Y年M月D日");
 */
function formatDate(time, formatStr = 'yyyy-MM-dd hh:mm:ss') {
  if (typeof time === "string") {
    time = time.replace(/-/g, '/');
  }
  let date = new Date(time);
  if (isNaN(date.getTime())) return "";
  var o = {
    "M+": date.getMonth() + 1, //月份 
    "d+": date.getDate(), //日 
    "h+": date.getHours(), //小时 
    "m+": date.getMinutes(), //分 
    "s+": date.getSeconds(), //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
    "S": date.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(formatStr))
    formatStr = formatStr.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(formatStr))
      formatStr = formatStr.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return formatStr;
}

export default {
  /**
   * 判断设备是否为 IOS
   */
  isIos() {
    let u = navigator.userAgent;
    return (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1)
  },

  /** 
   *拼接请求url的参数
  */
  joinParams(baseUrl, params) {
    let paramsArray = [];
    Object.keys(params).forEach(key => paramsArray.push(key + "=" + params[key]));
    if (baseUrl.indexOf("?") != -1) {
      baseUrl += "&" + paramsArray.join("&");
    } else {
      baseUrl += "?" + paramsArray.join("&");
    }
    return baseUrl;
  },

  /**
   * 删除URL中指定search参数,会将参数值一起删除
   * @param {string} url 地址字符串
   * @param {array} aParam 要删除的参数key数组，如['name','age']
   * @return {string} 返回新URL字符串
   */
  ridUrlParam(url, params) {
    for (let index = 0; index < params.length; index++) {
      let item = params[index];
      let fromIndex = url.indexOf(item + "="); //必须加=号，避免参数值中包含item字符串
      if (fromIndex !== -1) {
        // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
        let startIndex = url.indexOf("=", fromIndex);
        let endIndex = url.indexOf("&", fromIndex);
        let hashIndex = url.indexOf("#", fromIndex);

        let reg = "";
        if (endIndex !== -1) {
          // 后面还有search参数的情况
          let num = endIndex - startIndex;
          reg = new RegExp(item + "=.{" + num + "}");
          url = url.replace(reg, "");
        } else if (hashIndex !== -1) {
          // 有hash参数的情况
          let num = hashIndex - startIndex - 1;
          reg = new RegExp("&?" + item + "=.{" + num + "}");
          url = url.replace(reg, "");
        } else {
          // search参数在最后或只有一个参数的情况
          reg = new RegExp("&?" + item + "=.+");
          url = url.replace(reg, "");
        }
      }
    }
    let noSearchParam = url.indexOf("=");
    if (noSearchParam === -1) {
      url = url.replace(/\?/, ""); // 如果已经没有参数，删除？号
    }
    return url;
  },

  subFormatDate,
  formatDate,
  IOSFormtDate
}